<template>
  <div class="container py-2 px-5 d-flex border border-3 rounded-pill
    justify-content-between
    align-items-center
    shadow-sm my-4" v-if="user">
    <div class="">
      <h3 class="text-primary fw-bolder mb-0">Chat Box</h3>
    </div>
    <div class="d-flex align-items-center">
      <div class="info">
        <h4 class="mb-0">{{ user.displayName }}</h4>
        <p class="mb-0 text-black-50">{{ user.email }}</p>
      </div>
      <button
          class="btn btn-outline-success rounded-pill ms-3 h-25"
          @click="logOut">
        Log Out
      </button>
    </div>
  </div>
</template>

<script>
import {auth} from "@/firebase/config";
import {ref} from "vue";
import getUser from "@/composables/getUser";

export default {
  name: "Nav",
  setup(){
    let errorMessage = ref('');
    let logOut = async ()=>{
      try {
        await auth.signOut();
      }catch (e) {
        errorMessage.value = e.message;
        console.log(errorMessage.value);
      }
    };
    let {user} = getUser();
    return {logOut, user};
  }
}
</script>

<style scoped>

</style>